module.exports = __webpack_public_path__ + "static/media/marc.394bb8ec.jpg";